import variables from 'assets/styles/scss/shared/_variables.module.scss'

export const FilterSetStyles: any = (props?: any) => {
  const { isMobileView, anchorRef, disabledState, optionsLength } = props || {}
  return {
    selectFilters: {
      ...(!disabledState ? { backgroundColor: variables['light-blue'] } : {}),
      width: '52px',
    },
    paper: {
      maxHeight: '300px',
      overflowY: optionsLength > 8 ? 'scroll' : 'hidden',
      ...(isMobileView
        ? { width: anchorRef?.current?.clientWidth }
        : { width: 370 }),
      zIndex: -1,
    },
    butttonGroup: {
      ...(isMobileView ? {} : { height: 42, minWidth: 232 }),
      width: '100%',
    },
    savedFilter: {
      ...(!disabledState ? { backgroundColor: '#fff' } : {}),
      width: 'inherit',
      ...(isMobileView ? { textAlign: 'inherit' } : {}),
    },
    longTextStyle: {
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: 1.75,
      letterSpacing: '0.02857em',
      marginTop: '4px',
    },
  }
}
